import { createReducer, on } from '@ngrx/store';
import { initialDependencyState } from './dependency.state';
import * as DependencyActions from './dependency.actions';

export const dependencyReducer = createReducer(
  initialDependencyState,

  // Load Dependencies
  on(DependencyActions.loadDependencies, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(DependencyActions.loadDependenciesSuccess, (state, { dependencies }) => ({
    ...state,
    dependencies,
    loading: false,
    error: null
  })),

  on(DependencyActions.loadDependenciesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Load Parent Dependencies
  on(DependencyActions.loadParentDependencies, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(DependencyActions.loadParentDependenciesSuccess, (state, { parentDependencies }) => ({
    ...state,
    parentDependencies,
    loading: false,
    error: null
  })),

  on(DependencyActions.loadParentDependenciesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Create Dependency
  on(DependencyActions.createDependency, state => ({
    ...state,
    creating: true,
    error: null
  })),

  on(DependencyActions.createDependencySuccess, (state, { dependency }) => ({
    ...state,
    dependencies: [...state.dependencies, dependency],
    creating: false,
    error: null
  })),

  on(DependencyActions.createDependencyFailure, (state, { error }) => ({
    ...state,
    creating: false,
    error
  })),

  // Update Dependency
  on(DependencyActions.updateDependency, state => ({
    ...state,
    updating: true,
    error: null
  })),

  on(DependencyActions.updateDependencySuccess, (state, { dependency }) => ({
    ...state,
    dependencies: state.dependencies.map(d =>
      d.dependenciaId === dependency.dependenciaId ? dependency : d
    ),
    selectedDependency:
      state.selectedDependency?.dependenciaId === dependency.dependenciaId
        ? dependency
        : state.selectedDependency,
    updating: false,
    error: null
  })),

  on(DependencyActions.updateDependencyFailure, (state, { error }) => ({
    ...state,
    updating: false,
    error
  })),

  // Toggle Dependency Status
  on(DependencyActions.toggleDependencyStatus, state => ({
    ...state,
    toggling: true,
    error: null
  })),

  on(DependencyActions.toggleDependencyStatusSuccess, (state, { dependency }) => ({
    ...state,
    dependencies: state.dependencies.map(d =>
      d.dependenciaId === dependency.dependenciaId ? dependency : d
    ),
    selectedDependency:
      state.selectedDependency?.dependenciaId === dependency.dependenciaId
        ? dependency
        : state.selectedDependency,
    toggling: false,
    error: null
  })),

  on(DependencyActions.toggleDependencyStatusFailure, (state, { error }) => ({
    ...state,
    toggling: false,
    error
  })),

  // Search Dependencies
  on(DependencyActions.searchDependencies, state => ({
    ...state,
    searching: true,
    error: null
  })),

  on(DependencyActions.searchDependenciesSuccess, (state, { dependencies }) => ({
    ...state,
    searchResults: dependencies,
    searching: false,
    error: null
  })),

  on(DependencyActions.searchDependenciesFailure, (state, { error }) => ({
    ...state,
    searching: false,
    error
  })),

  // Select Dependency
  on(DependencyActions.selectDependency, (state, { dependency }) => ({
    ...state,
    selectedDependency: dependency
  })),

  // Clear Error
  on(DependencyActions.clearDependencyError, state => ({
    ...state,
    error: null
  })),

  // Reset State
  on(DependencyActions.resetDependencyState, () => initialDependencyState)
);
